import {z} from '@hono/zod-openapi';

export const extractDeliveryNoteDocumentResponseSchema = z.object({
  messageIds: z.array(z.string()),
});

export type ExtractDeliveryNoteDocumentResponse = z.infer<
  typeof extractDeliveryNoteDocumentResponseSchema
>;
